var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{key:_vm.inputKey,ref:"input",attrs:{"type":_vm.type},domProps:{"value":_vm.internalValue},on:{"input":function($event){return _vm.onInput($event.target.value)},"change":function($event){return _vm.$emit('change', $event.target.value)}}})
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }